import React, { useEffect, useState } from 'react'
import "./PurchaseHistory.css"
import { decryptData } from "../../common/encryptAnddecryptData";
import { GetPaymentHistory } from '../../Api/commonAPI';
import { formatCustomDate } from '../../common/common';

const PurchaseHistory = ({ token, userDetails, setIsPurchase }) => {

    const [history, setHistory] = useState([]);

    const [loading, setLoading] = useState(true);

    const fetchPaymentHistory = async () => {
        try {
            const response = await GetPaymentHistory(userDetails, token);
            const data = response.data;
            const decrypted = decryptData(data?.data);
            setHistory(decrypted);
            setLoading(false);
        } catch (error) {
            console.error("Points fetch error:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPaymentHistory()
    }, []);

    return (
        <>
            {!loading && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content" style={{ maxHeight: '80vh' }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Purchase History</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setIsPurchase(false)}
                                ></button>
                            </div>

                            <div className="modal-body overflow-auto" style={{ maxHeight: '60vh' }}>
                                {history?.length > 0 ? (
                                    history.map((item, index) => (
                                        <div
                                            key={index}
                                            className="mb-4 p-3 border rounded shadow-sm bg-light"
                                        >
                                            <div className="row mb-2">
                                                <div className="col-6 fw-bold">Date:</div>
                                                <div className="col-6">{formatCustomDate(item?.CreatedDate)}</div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6 fw-bold">Amount:</div>
                                                <div className="col-6">₹{item?.PaymentAmount}</div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6 fw-bold">Payment Method:</div>
                                                <div
                                                    className="col-6"
                                                >
                                                    {item?.PaymentMethod}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 fw-bold">Payment Status:</div>
                                                <div
                                                    className="col-6"
                                                    style={{ color: item?.PaymentStatus === "SUCCESS" ? 'green' : 'red' }}
                                                >
                                                    {item?.PaymentStatus}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="m-0">No purchase history available.</p>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button onClick={() => setIsPurchase(false)} className="close-warning-button">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default PurchaseHistory
